module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"other":"Ваша камера недоступна. Воспользуйтесь другим устройством.","notConnected":"Похоже, что ваша камера не подключена. Пожалуйста подключите камеру."}}')
  delete Component.options._Ctor
}
